module.exports = __webpack_public_path__ + "f6f74808bc76e0ee0174fb4d85fc97d8.png";